import { ChestSize } from './types'

export function getSpriteSize(size: ChestSize): [number, number] {
  switch (size) {
    case 'x-small':
      return [320, 240]

    case 'small':
      return [460, 345]

    case 'medium':
      return [640, 480]

    case 'medium-large':
      return [1366, 976]

    case 'large':
      return [1380, 1035]

    case 'xx-large':
      return [3290, 2350]

    default:
      return [0, 0]
  }
}

export function getLoaderSize(size: ChestSize): number {
  switch (size) {
    case 'x-small':
      return 24

    case 'small':
      return 32

    case 'medium':
      return 40

    case 'large':
      return 48

    default:
      return 0
  }
}

export function getChestcontentSize(size: ChestSize): string {
  switch (size) {
    case 'x-small':
      return 'scale-50 '

    case 'small':
      return 'scale-75'

    case 'medium':
      return 'scale-125 -mt-20'

    case 'large':
      return 'scale-150 -mt-24'

    default:
      return 'scale-1'
  }
}
